import { defineStore } from 'pinia';
import { computed, ref } from '@nuxtjs/composition-api';

export const useCartStore = defineStore('tlmCart', () => {
  const theCart = ref({})
  const cprNumber = ref({})
  const cvrNumber = ref({})
  const isProtectedAddress = ref(false)
  const paymentRef = ref('')
  const actionResponse = ref({})
  const cartScenarios = ref({})

  const getCart = computed(() => theCart.value)
  function setCart(cart) {
    // TEST: Simple assignment - if reactivity breaks, revert to deep clone
    // Deep clone was: JSON.parse(JSON.stringify(cart))
    // This ensures Vue detects all nested property changes
    theCart.value = cart
  }

  return {
    cartScenarios,
    setCart,
    getCart,
    theCart,
    cprNumber,
    cvrNumber,
    isProtectedAddress,
    paymentRef,
    actionResponse
  }
})
